<template>
    <div v-if="model">
        <v-dialog v-model="model" max-width="600">
            <v-card>
                <v-container>
                    <v-card-title>{{ model.id ? "Edit Login" : "New Login" }}</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="model.email" label="Email" />
                        <v-text-field v-model="model.displayName" label="Display name" />
                        <v-text-field type="password" v-model="model.password" :label="model.id ? 'New password (optional)' : 'Password'" />
                        <v-checkbox v-model="admin" label="Administrator" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="$emit('cancel')" text :disabled="loading">Cancel</v-btn>
                        <v-btn color="primary" @click="save()" :dark="!loading" depressed :disabled="loading">{{ model.id ? "Update" : "Create" }}</v-btn>
                    </v-card-actions>
                </v-container>
                <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { api } from '@/services/api';
import store from "@/services/store";

export default {
    props: ["model"],
    data: () => ({
        loading: false
    }),
    store,
    methods: {
        async save() {
            let req = {
                "id": this.model.id,
                "customerId": this.model.customerId,
                "email": this.model.email,
                "displayName": this.model.displayName,
                "password": this.model.password,
                "permissions": this.model.permissions
            };

            this.loading = true;

            await api("/admin/logins/save", req);

            this.$store.commit("update", {
                "email": this.model.email,
                "displayName": this.model.displayName
            });

            this.loading = false;

            this.$emit("close");
        }
    },
    computed: {
        admin: {
            get: function() {
                return this.model && this.model.permissions.includes("admin");
            },
            set: function(v) {
                if (!this.model)
                    return;
                let index = this.model.permissions.indexOf("admin");

                if (!v && index >= 0)
                    this.model.permissions.splice(index, 1);

                if (v && index == -1)
                    this.model.permissions.push("admin");
            }
        }
    }
};
</script>